export enum AuthenticationTask {
    // when a user is authenticated, it should show a spinner to indicate a redirect is in progress
    AutoLogin,
    // enter username password, or go to reset trigger view
    Login,
    // enter email that should receive reset code
    TriggerPasswordReset,
    // enter the reset code and set the new password
    ConfirmPasswordReset,
    // upon authentication, make the user change their password without any confirmation code
    ForcePasswordUpdate,
    // after the reset is finished, surface a notification on the main page
    FinishPasswordReset,
    // when users try to reset their password from the FORCE_CHANGE_PASSWORD status
    ResendPassword,
}

export enum AuthenticationError {
    InvalidPasswordReset = "Failed to send password reset code.",
    InvalidConfirmationCode = "Failed to reset password.",
}
